import {AuthProviderType} from "../domain/providers";

export type GoogleAnalyticsEvent = {
  eventCategory: string
  eventAction: string
  eventLabel?: string
  event?: string
}

const gaEvent = (event: GoogleAnalyticsEvent) => {
  console.debug("gaEvent", event)
  if (!window.dataLayer) {
    console.warn("window.dataLayer is not defined")
    return;
  }
  if (event.eventAction && !event.event) {
    event.event = `accounts_${event.eventAction.replace(/-/g, "_")}`;
  }
  window.dataLayer.push(event);
}

export const gaCreatedAccount = (authProvider: AuthProviderType) => {
  gaEvent({
    eventCategory: "admin",
    eventAction: "create_account",
    eventLabel: toLabel(authProvider),
  });
};

export const gaCreateAccountButtonClicked = () => {
  gaEvent({
    eventCategory: "onboarding",
    eventAction: "create_account_button_clicked",
  });
};

type ValidationError = "name" | "email_address" | "password" | "date_of_birth";
export const gaValidationError = (err: ValidationError) => {
  gaEvent({
    eventCategory: "onboarding",
    eventAction: "invalid_data_provided",
    eventLabel: err,
  });
}

export const gaLanguageChanged = (language: string) => {
  gaEvent({
    eventCategory: "onboarding",
    eventAction: "language_changed",
    eventLabel: language,
  })
}

export const gaEmailUnavailable = () => {
  gaEvent({
    eventCategory: "onboarding",
    eventAction: "email_unavailable",
  })
}

export const gaBackButtonClicked = () => {
  gaEvent({
    eventCategory: "onboarding",
    eventAction: "back_button_clicked",
    eventLabel: "page_create_your_account"
  })
};

type LoginLinkPage = "page_get_started" | "page_create_your_account";

export const gaLoginLinkClicked = (page: LoginLinkPage) => {
  gaEvent({
    eventCategory: "onboarding",
    eventAction: "login_link_clicked",
    eventLabel: page
  })
};


type AuthProviderLabel = "email" | "google" | "facebook" | "microsoft" | "apple" | "clever" | "classlink" | "unknown";

function toLabel(authProvider: AuthProviderType): AuthProviderLabel {
  return authProviderLabels[authProvider] || "unknown"
}

const authProviderLabels: { [key in AuthProviderType]: AuthProviderLabel } = {
  [AuthProviderType.Password]: "email",
  [AuthProviderType.Google]: "google",
  [AuthProviderType.Facebook]: "facebook",
  [AuthProviderType.Microsoft]: "microsoft",
  [AuthProviderType.Apple]: "apple",
  [AuthProviderType.Clever]: "clever",
  [AuthProviderType.ClassLink]: "classlink",
}
